import { Search, Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import classNames from "classnames";
import { useState } from "react";

/**
 * Custom input component with additional features like visibility toggle for passwords.
 * @param {import("@mui/material").TextFieldProps} props - Props object.
 * @param {("start" | "end" | "center" | "justify" | "left" | "right")} [props.textAlign="start"] - Text alignment.
 */
const CustomInput = ({
  type = "",
  value,
  onChange,
  label = "",
  className = "",
  containerClassName = "",
  id = "",
  size = "small",
  InputProps,
  onBlur,
  isRequired = false,
  text = "base",
  paddingX = 3,
  textAlign = "start",
  ...rest
}) => {
  const [isVisible, setIsVisible] = useState({ [id]: false });
  return (
    <div
      className={classNames("flex flex-col justify-center", containerClassName)}
    >
      {label && (
        <p className="m-1 font-semibold whitespace-nowrap">
          {label}
          {isRequired && <span className="text-red-800">*</span>}
        </p>
      )}
      <TextField
        id={id}
        name={id}
        type={type !== "password" ? type : isVisible[id] ? "text" : "password"}
        size={size}
        inputProps={{
          className:
            type === "file"
              ? `!pt-1.5 !pl-1.5 !pb-3`
              : `!text-${text} text-${textAlign} !px-${paddingX}`,
        }}
        InputProps={{
          ...InputProps,
          ...(type === "search" && {
            endAdornment: <Search className="text-black text-opacity-60" />,
          }),
          ...(type === "password" && {
            endAdornment: (
              <IconButton
                size="small"
                onClick={() => setIsVisible({ [id]: !isVisible[id] })}
              >
                {isVisible[id] ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }),
        }}
        onBlur={onBlur}
        value={value}
        onChange={onChange}
        className={classNames(
          "!outline-none placeholder:!text-gray-100 !capitalize !bg-white !bg-opacity-20 !border-opacity-30 !border !border-white",
          className
        )}
        {...rest}
      />
    </div>
  );
};

export default CustomInput;
